import { Layout } from 'antd'
import { observer } from 'mobx-react-lite'
import { useRouteMatch } from 'react-router-dom'
import Sidebar from '../sidebar/Sidebar'
import { useStore } from '../../../hooks'
import { TAB_SIZE } from '../../../helpers/constants'
import SidebarContent from '../sidebar/SidebarContent'
import UserProfile from '../sidebar/UserProfile'
import Images from '../../../common/Images'
import { supporterMeta } from '../../routes/metaData'
import { useEffect } from 'react'
import StickyChatButton from 'src/common/components/sticky-chat/StickyChatButton'
import SupporterRouters from '../../routes/SupporterRouters'
import UserNotification from '../sidebar/UserNotification'

const { Content } = Layout
const { Sider } = Layout

const LayoutSupporter = observer((props: any) => {
   const match = useRouteMatch()
   const AuthStore = useStore('AuthStore')
   const isDesktop = AuthStore.width_screen >= TAB_SIZE
   const handleOpenSidebar = () => {
      AuthStore.action_openSidebar()
   }
   const handleToggleCollapsed = () => {
      AuthStore.action_toggleSidebarCollapsed()
   }
   const UserStore = useStore('UserStore')

   useEffect(() => {
      getListData()
   }, [])

   const getListData = async () => {
      try {
         await UserStore.getCreators()
         await UserStore.getDesigners()
         await UserStore.getApprovers()
      } catch (error) {
         // console.log(error)
      } finally {
      }
   }
   // console.log('supporterMeta: ', supporterMeta)

   return (
      <Layout className="gx-app-layout layout-admin">
         {/* <StickyChatButton /> */}
         <Sider
            className={`gx-app-sidebar gx-layout-sider-dark`}
            trigger={null}
            collapsed={isDesktop && AuthStore.sidebarCollapsed}
            collapsedWidth={80}
            theme={'dark'}
            collapsible
         >
            {AuthStore.width_screen < TAB_SIZE ? (
               <Sidebar {...props} sideBarContent={supporterMeta} />
            ) : (
               <SidebarContent
                  {...props}
                  sideBarContent={supporterMeta}
                  collapsed={AuthStore.sidebarCollapsed}
                  onToggleCollapsed={handleToggleCollapsed}
               />
            )}
         </Sider>
         <Layout>
            {AuthStore.width_screen < TAB_SIZE && (
               <div className="gx-linebar header-mobile-container">
                  <div>
                     <i className="gx-icon-btn icon icon-menu" onClick={handleOpenSidebar} />
                  </div>

                  <div className="center-img-content2">
                     <img src={Images.logo_white} className="img-responsive" alt="Logo" />
                  </div>

                  <div>
                     <UserProfile />
                  </div>
                  {/* <div>
                    <UserNotification />
                  </div> */}
               </div>
            )}
            <Content className={`gx-layout-content gx-main-content-wrapper`}>
               <SupporterRouters match={match} />
            </Content>
            {/* <CustomizerBar /> tam an di*/}
         </Layout>
      </Layout>
   )
})

export default LayoutSupporter
